import styles from './styles.module.scss';

const Objective = () => (
  <div>
    <div className={styles.objectiveContainer}>
      <div className={styles.title}>Through our application,</div>
      <div className={styles.content}>
        We strive to empower employees to celebrate achievements, showcase their appreciation for
        one another, and build strong connection with companies.
      </div>
      <br />
      <div className={styles.content}>
        By offering a robust platform that combines{' '}
        <span className={styles.highlight}>rewards</span>,{' '}
        <span className={styles.highlight}>interactive content</span>, and{' '}
        <span className={styles.highlight}>seamless communication</span>, we aim to enhance the
        employee experience, foster a positive work environment, and positively impact
        organisational performance.
      </div>
    </div>
  </div>
);

export default Objective;
